<div id="alert" [ngClass]="{'success': className == 's', 'error': className == 'e'}" class="alert-swipe ">
    <div class="alert-swipe-container">
        <div class="col-md-12 col-sm-12 col-xs-12 alert-pad-l-r-0 alert-border">
            <div class="alert-img-bg">
                <img class="alert-swipte-left-img alert-img" src="assets/images/set-filter.png">
                <img class="alert-swipte-left-img alert-error-img" src="assets/images/alert-error.png">
            </div>
            <div class="alert-text-display">
                <a href="javascript:void(0);" data-dismiss="modal">
                    <img class="alert-close-img yellow-close-img" src="assets/images/yellow-close.png">
                    <img class="alert-close-img red-close-img" src="assets/images/red-close.png">
                </a>

                <div class="member-success-text red blue">{{message}}</div>
            </div>
        </div>
    </div>
</div>